export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./accept-lead-modal.vue?vue&type=template&id=ce7b9216&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/accept-lead-modal.vue?vue&type=template&id=ce7b9216&
// module id = 1422
// module chunks = 0